








import { Session } from '../../utils/Session';
import { Vue, Component, Prop } from 'vue-property-decorator';
import LessonMessages from '../../components/messages/LessonMessages.vue';

@Component({ components: { LessonMessages } })
export default class TeacherMessagesPage extends Vue {
  get ownerUserId() {
    return Session.getSessionUserId();
  }
  get ownerUserType() {
    return Session.getSessionUserType();
  }
}
